module.exports = __webpack_public_path__ + "static/media/information.9aaa4def.svg";